import { connect } from 'react-redux';
import { Routes, Route, Navigate } from 'react-router-dom';

import { CONSTANTS } from 'src/commons';
import DashboardLayout from 'src/components/DashboardLayout';
import MemberList from 'src/pages/MemberList/index';
import Message from 'src/pages/Message';
import Dashboard from 'src/pages/Dashboard/index';
import {
  AddMember,
  AddQuery,
  ChangePassword,
  EditProfile,
  Queries,
  Records,
  Trainer,
  UpdateMember
} from 'src/pages';
import AddMessage from 'src/pages/Message/AddMessage/';
import { startLoading, stopLoading } from 'src/redux/actions';
import Loader from 'src/components/Loader';
import AddTrainer from 'src/pages/Trainer/AddTrainer';
import UpdateTrainer from 'src/pages/Trainer/UpdateTrainer';
import DeleteAdmin from 'src/pages/DeleteAdmin';
import Batches from 'src/pages/Batches';
import AddBatch from 'src/pages/Batches/AddBatch';
import UpdateBatch from 'src/pages/Batches/UpdateBatch';
import AddMembershipPlan from 'src/pages/MembershipPlans/AddMembership';
import UpdateMembershipPlan from 'src/pages/MembershipPlans/UpdateMembership';
import MambershipPlan from 'src/pages/MembershipPlans';
import Payment from 'src/pages/Payment';
import AddPayment from 'src/pages/Payment/AddPayment';
import UpdatePayment from 'src/pages/Payment/UpdatePayment';
import PendingPayments from 'src/pages/Records/components/pendingPayments';
import MembershipThisMonth from 'src/pages/Records/components/membershipsThisMonth';
import ExpiringMemberships from 'src/pages/Records/components/expiringMemberships';
import ExpiredMemberships from 'src/pages/Records/components/expiredMemberships';
import FollowUpsQueries from 'src/pages/Records/components/Queries';
import Gym from 'src/pages/Allgyms'
import DietPlan from 'src/pages/DietPlan'
import UpdateDietPlan from 'src/pages/DietPlan/UpdateDietPlan'
import AddDietPlan from 'src/pages/DietPlan/AddDietPlan'
import Earnings from 'src/pages/Earnings'
import Annivesaries from 'src/pages/Annivesaries'

const PrivateRoutes = ({ loading, startLoading, stopLoading }) => {
  const PRIVATE_ROUTES = CONSTANTS.ROUTES.PRIVATE_ROUTES;
  const propsToPass = {
    startLoading,
    stopLoading
  };
  return (
    <DashboardLayout>
      {loading ? <Loader /> : null}
      <Routes>
        <Route
          path={PRIVATE_ROUTES.DASHBOARD}
          element={<Dashboard {...propsToPass} />}
        />
        <Route
          path={PRIVATE_ROUTES.ADD_MESSAGE}
          element={<AddMessage {...propsToPass} />}
        />
        <Route
          path={PRIVATE_ROUTES.MESSAGE}
          element={<Message {...propsToPass} />}
        />
        <Route
          path={PRIVATE_ROUTES.RECORDS}
          element={<Records {...propsToPass} />}
        />
        <Route
          path={PRIVATE_ROUTES.ADD_QUERY}
          element={<AddQuery {...propsToPass} />}
        />
        <Route
          path={PRIVATE_ROUTES.QUERIES}
          element={<Queries {...propsToPass} />}
        />
        <Route
          path={PRIVATE_ROUTES.EARNINGS}
          element={<Earnings {...propsToPass} />}
        />
        <Route
          path={PRIVATE_ROUTES.ADD_MEMBER}
          element={<AddMember {...propsToPass} />}
        />
        <Route
          path={PRIVATE_ROUTES.ADD_TRAINER}
          element={<AddTrainer {...propsToPass} />}
        />
        <Route
          path={PRIVATE_ROUTES.ADD_MEMBERSHIP_PLAN}
          element={<AddMembershipPlan {...propsToPass} />}
        />
        <Route
          path={`${PRIVATE_ROUTES.EDIT_MEMBER}/:id`}
          element={<UpdateMember {...propsToPass} />}
        />
        <Route
          path={`${PRIVATE_ROUTES.EDIT_TRAINER}/:id`}
          element={<UpdateTrainer {...propsToPass} />}
        />
        <Route
          path={`${PRIVATE_ROUTES.EDIT_MEMBERSHIP_PLAN}/:id`}
          element={<UpdateMembershipPlan {...propsToPass} />}
        />
        <Route
          path={PRIVATE_ROUTES.CHANGE_PASSWORD}
          element={<ChangePassword {...propsToPass} />}
        />
        <Route
          path={PRIVATE_ROUTES.MEMBERS}
          element={<MemberList {...propsToPass} />}
        />
        <Route
          path={PRIVATE_ROUTES.TRAINER}
          element={<Trainer {...propsToPass} />}
        />
        <Route
          path={PRIVATE_ROUTES.MEMBERSHIP_PLAN}
          element={<MambershipPlan {...propsToPass} />}
        />
        <Route
          path={PRIVATE_ROUTES.EDIT_PROFILE}
          element={<EditProfile {...propsToPass} />}
        />
        <Route
          path={PRIVATE_ROUTES.DELETE_ADMIN}
          element={<DeleteAdmin {...propsToPass} />}
        />
        <Route
          path={PRIVATE_ROUTES.BATCHES}
          element={<Batches {...propsToPass} />}
        />
        <Route
          path={PRIVATE_ROUTES.ADD_BATCH}
          element={<AddBatch {...propsToPass} />}
        />
        <Route
          path={`${PRIVATE_ROUTES.EDIT_BATCH}/:id`}
          element={<UpdateBatch {...propsToPass} />}
        />
        <Route
          path={`${PRIVATE_ROUTES.PAYMENT}/:member_id`}
          element={<Payment {...propsToPass} />}
        />
        <Route
          path={`${PRIVATE_ROUTES.ADD_PAYMENT}/:member_id`}
          element={<AddPayment {...propsToPass} />}
        />
        <Route
          path={`${PRIVATE_ROUTES.EDIT_PAYMENT}/:id`}
          element={<UpdatePayment {...propsToPass} />}
        />
        <Route
          path={`${PRIVATE_ROUTES.PENDING_PAYMENT}`}
          element={<PendingPayments {...propsToPass} />}
        />
        <Route
          path={`${PRIVATE_ROUTES.THIS_MONTH_MEMBERSHIP}`}
          element={<MembershipThisMonth {...propsToPass} />}
        />
        <Route
          path={`${PRIVATE_ROUTES.MEMBERSHIP_EXPIRED_THIS_MONTH}`}
          element={<ExpiringMemberships {...propsToPass} />}
        />
        <Route
          path={`${PRIVATE_ROUTES.ANNIVESARIES}`}
          element={<Annivesaries {...propsToPass} />}
        />
        <Route
          path={`${PRIVATE_ROUTES.EXPIRED_MEMBERSHIP}`}
          element={<ExpiredMemberships {...propsToPass} />}
        />
        <Route
          path={`${PRIVATE_ROUTES.EXPIRED_MEMBERSHIP}`}
          element={<ExpiredMemberships {...propsToPass} />}
        />
        <Route
          path={`${PRIVATE_ROUTES.QUERIES_FOLLOWUPS}`}
          element={<FollowUpsQueries {...propsToPass} />}
        />
        <Route
          path={`${PRIVATE_ROUTES.ALL_GYMS}`}
          element={<Gym {...propsToPass} />}
        />
        <Route
          path={`${PRIVATE_ROUTES.ADD_DIET_PLAN}`}
          element={<AddDietPlan {...propsToPass} />}
        />
        <Route
          path={`${PRIVATE_ROUTES.EDIT_DIET_PLAN}/:dietPlanId`}
          element={<UpdateDietPlan {...propsToPass} />}
        />
        <Route
          path={`${PRIVATE_ROUTES.DIET_PLAN}`}
          element={<DietPlan {...propsToPass} />}
        />

        <Route
          path={'*'}
          element={<Navigate path={'/'} to={PRIVATE_ROUTES.RECORDS} exact />}
        />
        <Route
          path={'*'}
          element={<Navigate to={CONSTANTS.ROUTES.PRIVATE_ROUTES.RECORDS} />}
        />
      </Routes>
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.loader.loading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    startLoading: () => dispatch(startLoading()),
    stopLoading: () => dispatch(stopLoading())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoutes);
